/* CSS Custom Properties for dynamic configuration */
.container {
  position: relative;
  overflow: hidden;
  perspective: var(--cylinder-perspective, 1000px);
}

.cylinder {
  position: relative;
  width: 100%;
  height: 100%;
  transform-style: preserve-3d;
  /* Rotation is controlled by Web Animations API */
  transform: rotateX(var(--cylinder-rotation, 0deg));
}

.face {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  backface-visibility: hidden;
  /* Transform is set via inline style for dynamic positioning */
  transition: opacity 0.3s ease;
}

.face.visible {
  opacity: 1;
  pointer-events: auto;
}

.face.hidden {
  opacity: 0;
  pointer-events: none;
}

/* Optional: Add will-change for performance on faces that are animating */
.cylinder.animating .face {
  will-change: opacity;
}

.cylinder.animating {
  will-change: transform;
}
